import React from "react";
import styled from 'styled-components';
import { MdHistoryToggleOff } from "react-icons/md";

const TransactionHistory = () => {
    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div>
                                <h4 className="text-dark mb-1 d-flex align-items-center">
                                    <MdHistoryToggleOff className="sideicon" size={22} color="black" />
                                    Transaction Log
                                </h4>
                                <p className="text-muted mb-0">View, filter, and manage all ticket records.</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                            <div className="flex-grow-1" style={{ maxWidth: "300px" }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by ID, Visitor, Phone..."
                                />
                            </div>
                            <div className="d-flex flex-wrap gap-2">
                                <button className="btn btn-outline-secondary">All Tickets</button>
                                <button className="btn btn-outline-secondary">All Spots</button>
                                <button className="btn btn-outline-secondary">Ticket Status</button>
                                <button className="btn btn-outline-secondary">All Time</button>
                                <button className="btn btn-outline-secondary">Export</button>
                                <button className="btn btn-outline-danger">Clear Filters</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover align-middle table-bordered">
                                <thead className="table-light">
                                    <tr>
                                        <th>Ticket ID</th>
                                        <th>Transaction ID</th>
                                        <th>Visitor</th>
                                        <th>Date & Time</th>
                                        <th>Type</th>
                                        <th>Qty</th>
                                        <th>Status</th>
                                        <th>Amount</th>
                                        <th>⋯</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>ONL_DASH002</td>
                                        <td>TRX013</td>
                                        <td><strong>Carol Danvers</strong><br /><small className="text-muted">555-0109</small></td>
                                        <td>24 Jul 2024, 7:30 PM</td>
                                        <td><span className="badge bg-primary">Online</span></td>
                                        <td>3</td>
                                        <td><span className="badge bg-success">Successful</span></td>
                                        <td>$90.00</td>
                                        <td><button className="btn btn-sm btn-light">...</button></td>
                                    </tr>
                                    <tr>
                                        <td>CNT_DASH002</td>
                                        <td>TRX014</td>
                                        <td><strong>David Banner</strong><br /><small className="text-muted">555-0110</small></td>
                                        <td>13 May 2025, 11:14 AM</td>
                                        <td><span className="badge badge-counter">Counter</span></td>
                                        <td>2</td>
                                        <td><span className="badge bg-success">Successful</span></td>
                                        <td>$50.00</td>
                                        <td><button className="btn btn-sm btn-light">...</button></td>
                                    </tr>
                                    <tr>
                                        <td>ONL_DASH003</td>
                                        <td>TRX015</td>
                                        <td><strong>Eve Moneypenny</strong><br /><small className="text-muted">555-0111</small></td>
                                        <td>20 Mar 2025, 11:14 AM</td>
                                        <td><span className="badge bg-primary">Online</span></td>
                                        <td>1</td>
                                        <td><span className="badge bg-success">Successful</span></td>
                                        <td>$15.00</td>
                                        <td><button className="btn btn-sm btn-light">...</button></td>
                                    </tr>
                                    <tr>
                                        <td>CNT_DASH003</td>
                                        <td>TRX016</td>
                                        <td><strong>Frank Castle</strong><br /><small className="text-muted">555-0112</small></td>
                                        <td>20 Apr 2025, 11:14 AM</td>
                                        <td><span className="badge badge-counter">Counter</span></td>
                                        <td>4</td>
                                        <td><span className="badge bg-success">Successful</span></td>
                                        <td>$120.00</td>
                                        <td><button className="btn btn-sm btn-light">...</button></td>
                                    </tr>
                                    <tr>
                                        <td>TKT_FAIL01</td>
                                        <td>TRX017</td>
                                        <td><strong>Error Prone</strong><br /><small className="text-muted">555-0113</small></td>
                                        <td>26 Jul 2024, 3:30 PM</td>
                                        <td><span className="badge bg-primary">Online</span></td>
                                        <td>1</td>
                                        <td><span className="badge bg-danger">Failed</span></td>
                                        <td>$0.00</td>
                                        <td><button className="btn btn-sm btn-light">...</button></td>
                                    </tr>
                                    <tr>
                                        <td>CNT_REFUND01</td>
                                        <td>TRX018</td>
                                        <td><strong>Changed Mind</strong><br /><small className="text-muted">555-0114</small></td>
                                        <td>20 Jul 2024, 8:30 PM</td>
                                        <td><span className="badge badge-counter">Counter</span></td>
                                        <td>2</td>
                                        <td><span className="badge bg-warning text-dark">Refunded</span></td>
                                        <td>$0.00</td>
                                        <td><button className="btn btn-sm btn-light">...</button></td>
                                    </tr>
                                    <tr>
                                        <td>ONL_PEND01</td>
                                        <td>TRX019</td>
                                        <td><strong>Waiting Payment</strong><br /><small className="text-muted">555-0115</small></td>
                                        <td>27 Jul 2024, 2:30 PM</td>
                                        <td><span className="badge bg-primary">Online</span></td>
                                        <td>2</td>
                                        <td><span className="badge bg-info text-dark">Pending</span></td>
                                        <td>$0.00</td>
                                        <td><button className="btn btn-sm btn-light">...</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default TransactionHistory;

const Wrapper = styled.div`
  .badge {
    padding: 5px 10px;
    border-radius: 15px;
    font-weight: 500;
    font-size: 0.875rem;
    display: inline-block;
  }

  .badge-counter {
    background-color: rgba(123, 79, 169, 0.15); /* Purple with 15% opacity */
    color: #7B4FA9;
    font-size:10px;
  }

  .bg-primary {
    background-color: rgba(13, 110, 253, 0.15) !important; /* Bootstrap Primary */
    color: #0d6efd !important;
    font-size:10px;
    padding:5px 10px;
  }

  .bg-success {
    background-color: rgba(25, 135, 84, 0.15) !important;
    color: #198754 !important;
    font-size:10px;
  }

  .bg-danger {
    background-color: rgba(220, 53, 69, 0.15) !important;
    color: #dc3545 !important;
    font-size:10px;
  }

  .bg-warning {
    background-color: rgba(255, 193, 7, 0.15) !important;
    color: #ffc107 !important;
    font-size:10px;
  }

  .bg-info {
    background-color: rgba(13, 202, 240, 0.15) !important;
    color: #0dcaf0 !important;
    font-size:10px;
  }
`;

